module.exports = __webpack_public_path__ + "img/katarina_events_10.f3c790f8.jpg";